<nb-layout>
  <nb-layout-header class="nb-layout-header">

    <!-- Ряд 1: лого · Каталог · поиск · действия (уведомления / профиль / корзина) -->
    <div class="bottom-line">
      <div class="header__left">
        <a href="/catalog" (click)="toggleSidebar()" class="sidebar-toggle sidebar-menu mobile-menu-icon">
          <img class="menu-close" src="/assets/images/header/menu-close.svg" alt="">
          <img class="menu-open" src="/assets/images/header/menu-open.svg" alt="">
        </a>
        @if (!isHomePage) {
          <a class="top-logo" [routerLink]="['/']"> <img alt="logo" class="logo" src="/assets/images/logo.svg"> <img alt="logo" class="logo-mobile" src="/assets/images/mobile-logo.svg"> </a>
        } @else {
          <span class="top-logo"> <img alt="logo" class="logo" src="/assets/images/logo.svg"> <img alt="logo" class="logo-mobile" src="/assets/images/mobile-logo.svg"> </span>
        }
        <app-modal-catalog/>

        @if (!authService.isAnonymous()) {
          <button (click)="openExcelExportWindow()" nbButton i18n="@@PriceList">
            <tui-icon icon="file-down"/>
            Прайс
          </button>
        }
      </div>

      <div class="header-center">
        <div class="header-center__content">
          <div class="header-filter" (click)="toggleFilter();">
            <tui-icon icon="settings-2"/>
            <app-filter-count [filter]="productFilter"/>
          </div>
          <div class="mob-search" (click)="openSearch();">
            <img class="icon-search" src="/assets/images/header/mob-search.svg" alt="">
          </div>
          @if (isShowSearch) {
            <div class="header-search">
              <app-search-autocomplete/>
            </div>
          }
          <div class="header-search">
            <app-search-autocomplete/>
          </div>
        </div>
      </div>

      <div class="header-actions">
        @if (!isShowcase) {
          @if (!authService.isAnonymous()) {
            <a class="header-icon-btn" routerLink="/account/notifications" title="Уведомления" i18n-title="@@Notifications">
              <tui-icon icon="bell"/>
            </a>
            <span class="header-divider"></span>
          }

          @if (authService.isAnonymous()) {
            <div class="user-action">
              <button nbButton status="primary" (click)="open()" i18n="@@Enter">
                <tui-icon icon="user-round"/>
                Войти
              </button>
            </div>
          } @else {
            <a class="header-icon-btn" [matMenuTriggerFor]="menu" title="Профиль" i18n-title="@@Profile">
              <tui-icon icon="user-round"/>
            </a>
            <mat-menu #menu="matMenu" xPosition="before">
              <p class="header">{{ customer?.company }}</p>
              @for (item of itemsProfile; track item.title) {
                <button [routerLink]="item.link" mat-menu-item (click)="item?.click?.()">
                  {{ item.title }}
                </button>
              }
            </mat-menu>
          }
          <span class="header-divider"></span>
        }

        <app-basket-header/>
      </div>
    </div>

    <!-- Ряд 2: горизонтальное меню · телефон · город · компания -->
    @if (!isShowcase) {
      <div class="header-nav-line">
        <div class="header-nav">
          @if (menuItems$ | async; as items) {
            @for (item of items; track $index) {
              <div class="header-nav__item">
                <a class="header-nav__link" [routerLink]="item.link" [queryParams]="item.queryParams"
                  routerLinkActive="header-nav__link--active">
                  {{ item.title }}
                  @if (item.children?.length) {
                    <tui-icon icon="chevron-down" class="header-nav__caret"/>
                  }
                </a>
                @if (item.children?.length) {
                  <div class="header-nav__submenu">
                    @for (child of item.children; track $index) {
                      <a class="header-nav__subitem" [routerLink]="child.link" [queryParams]="child.queryParams"
                      routerLinkActive="header-nav__subitem--active">{{ child.title }}</a>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>

        <div class="header-nav__meta">
          <app-locale-switcher/>

          <button type="button" class="header-meta-btn" [matMenuTriggerFor]="menuPhone">
            <tui-icon icon="phone"/>
            <span>{{ settings?.phone }}</span>
          </button>
          <mat-menu #menuPhone="matMenu" xPosition="before" class="phone-modal">
            <h6>
              {{ translations.schedule }} <br> <small>{{ translations.holidays }}</small>
            </h6>
            @if (settings) {
              <p>{{ settings.phone }}<br> <a href="mailto:{{ settings.mainEmail }}">{{ settings.mainEmail }}</a></p>
            }
          </mat-menu>

          <button type="button" class="header-meta-btn" (click)="openLocationWindow()">
            <tui-icon icon="navigation"/>
            @if (customerGroup$ | async; as customerGroup) {
              <span>{{ customerGroup.header }}</span>
            }
          </button>

          @if (!authService.isAnonymous()) {
            <button type="button" class="header-meta-btn" (click)="openCompanyWindow()">
              <tui-icon icon="bookmark"/>
              @if (contract) {
                <span i18n="@@Company">{{ contract.counterParty.company }}</span>
              }
              <tui-icon icon="chevron-down"/>
            </button>
          }
        </div>
      </div>
    }
  </nb-layout-header>


  @if (!isShowcase) {
    <nb-sidebar [state]="sideBarState" (mouseleave)="toggleSidebar(false)">
      <div (mouseenter)="toggleSidebar(true)">
        <div class="mobileMenu">
          <div class="mobileMenu__top">
            <p i18n="@@Menu">Меню</p>
            <!--        <div class="mobileMenu__icon" (click)="toggleSidebar();">-->
            <!--          <span i18n="@@Close">Закрыть</span> <img src="/assets/images/header/menu-open.svg" alt="">-->
          <!--        </div>-->
        </div>
      </div>
      <span class="sidebar-toggle sidebar-menu">
        <img class="menu-close" src="/assets/images/header/menu-close.svg" alt="">
        <!--      <img class="menu-open" src="/assets/images/header/menu-open.svg" alt="">-->
        <!--      <span class="menu-open" i18n="@@Close">Закрыть</span>-->
      </span>
      @if (menuItems$ | async; as items) {
        @if (isFullMenu && items?.length) {
          <nb-menu [items]="items"/>
        }
        @if (!isFullMenu && items?.length) {
          <app-compact-menu [items]="items"/>
        }
      }
    </div>
  </nb-sidebar>
}

<nb-layout-column>
  <app-breadcrumb [separator]="crumbSeparator" [hidden]="isHomePage || !breadcrumbService.showBreadCrumbs()">
    <ng-container *xngBreadcrumbItem="let breadcrumb">
      {{ breadcrumb }}
    </ng-container>
  </app-breadcrumb>
  <ng-template #crumbSeparator><tui-icon icon="chevron-right"/></ng-template>

  <div class="center-block center-products" [ngClass]="isShowFilter ? 'checkedFilter' : ''">
    <div class="nb-filter" [hidden]="!isShowFilter">
      <div class="nb-filter__top">
        <div class="title" i18n="@@Filter">Фильтр товаров</div>
        <tui-icon icon="x" (click)="toggleFilter();" style="cursor: pointer"/>
      </div>
      <app-filter [filter]="productFilter"/>
    </div>
    <div class="center-block__content">
      <router-outlet />
    </div>
  </div>

  @if (!isShowcase) {
    <nb-layout-footer>
      <div class="footer">
        <div class="footer__top">
          <div class="footer__brand">
            <a class="footer-logo" routerLink="/">
              <img alt="logo" class="logo" src="/assets/images/{{ theme === 'dark' ? 'logo_dark.svg' : 'logo.svg' }}">
            </a>
            @if (settings) {
              <a class="footer__phone" href="tel:{{ settings.phone }}" [textContent]="settings.phone"></a>
              <a class="footer__email" href="mailto:{{ settings.mainEmail }}">{{ settings.mainEmail }}</a>
            }
          </div>
          <div class="footer__links">
            <page-link position="footer"/>
            <a routerLink="/pages/where-to-buy" i18n="@@WhereToBuy">Где Купить</a>
            <button type="button" class="footer-action-link" i18n="@@suggestIdea" (click)="openSuggestIdeaModal($event)">Предложить идею</button>
          </div>
          @if (socialLinks?.vkLink || socialLinks?.telegramLink) {
            <div class="footer__socials">
              @if (socialLinks?.vkLink) {
                <a [href]="socialLinks.vkLink" target="_blank" rel="noopener">
                  <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M18.4493 16.0002H16.9203C16.3414 16.0002 16.1633 15.559 15.1241 14.5483C14.2186 13.7084 13.8178 13.5946 13.5951 13.5946C13.2834 13.5946 13.1943 13.68 13.1943 14.0928V15.4166C13.1943 15.7725 13.0755 15.986 12.0958 15.986C10.4777 15.986 8.6815 15.0465 7.41969 13.2956C5.51957 10.7333 5 8.81163 5 8.41306C5 8.19953 5.08907 8.00024 5.51957 8.00024H7.04858C7.43454 8.00024 7.58299 8.17106 7.73143 8.56964C8.48852 10.6622 9.75032 12.4985 10.2699 12.4985C10.4629 12.4985 10.5519 12.4131 10.5519 11.9433V9.7796C10.4926 8.78316 9.9433 8.69775 9.9433 8.34188C9.9433 8.17106 10.0917 8.00024 10.3293 8.00024H12.7341C13.0607 8.00024 13.1795 8.17106 13.1795 8.54117V11.4593C13.1795 11.7725 13.3279 11.8864 13.417 11.8864C13.61 11.8864 13.7732 11.7725 14.1295 11.4308C15.228 10.2494 16.0148 8.42729 16.0148 8.42729C16.1187 8.21377 16.2969 8.01448 16.6828 8.01448H18.2118C18.672 8.01448 18.7759 8.24224 18.672 8.5554C18.479 9.4095 16.6086 11.9433 16.6086 11.9433C16.4453 12.1995 16.3859 12.3134 16.6086 12.5981C16.7719 12.8116 17.3063 13.2529 17.6626 13.6515C18.3157 14.3632 18.8205 14.9611 18.9541 15.3739C19.1025 15.7867 18.8798 16.0002 18.4493 16.0002Z" fill="currentColor"/></svg>
                  <span i18n="@@SocialVk">Вконтакте</span>
                </a>
              }
              @if (socialLinks?.telegramLink) {
                <a [href]="socialLinks.telegramLink" target="_blank" rel="noopener">
                  <svg viewBox="0 0 26 26" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M18.384,22.779c0.322,0.228 0.737,0.285 1.107,0.145c0.37,-0.141 0.642,-0.457 0.724,-0.84c0.869,-4.084 2.977,-14.421 3.768,-18.136c0.06,-0.28 -0.04,-0.571 -0.26,-0.758c-0.22,-0.187 -0.525,-0.241 -0.797,-0.14c-4.193,1.552 -17.106,6.397 -22.384,8.35c-0.335,0.124 -0.553,0.446 -0.542,0.799c0.012,0.354 0.25,0.661 0.593,0.764c2.367,0.708 5.474,1.693 5.474,1.693c0,0 1.452,4.385 2.209,6.615c0.095,0.28 0.314,0.5 0.603,0.576c0.288,0.075 0.596,-0.004 0.811,-0.207c1.216,-1.148 3.096,-2.923 3.096,-2.923c0,0 3.572,2.619 5.598,4.062Zm-11.01,-8.677l1.679,5.538l0.373,-3.507c0,0 6.487,-5.851 10.185,-9.186c0.108,-0.098 0.123,-0.262 0.033,-0.377c-0.089,-0.115 -0.253,-0.142 -0.376,-0.064c-4.286,2.737 -11.894,7.596 -11.894,7.596Z" fill="currentColor"/></svg>
                  <span i18n="@@SocialTelegram">Telegram</span>
                </a>
              }
            </div>
          }
          <button type="button" class="footer__back" (click)="scrollToTop()">
            <span i18n="@@FooterBackToTop">Вернуться назад</span>
            <tui-icon icon="arrow-up"/>
          </button>
        </div>
        <div class="footer__bottom">
          <!-- Юр-ссылки (Политика/Соглашение/Оферта) из макета: нужен источник (CMS page-link position) — пока не выводим. -->
          <div class="footer__bottom-left"></div>
          <!--          <div class="footer__bottom-center">-->
          <!--            <p i18n="@@SocialNetworks">Социальные сети</p>-->
          <!--            <div class="footer__social">-->
          <!--              <a *ngIf="socialLinks.instagramLink" href="{{socialLinks.instagramLink}}" target="_blank">-->
          <!--                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
          <!--                  <path-->
          <!--                    d="M15 4.00024H9C6.2375 4.00024 4 6.23774 4 9.00024V15.0002C4 17.7627 6.2375 20.0002 9 20.0002H15C17.7625 20.0002 20 17.7627 20 15.0002V9.00024C20 6.23774 17.7625 4.00024 15 4.00024ZM18.5 15.0002C18.5 16.9315 16.9312 18.5002 15 18.5002H9C7.06875 18.5002 5.5 16.9315 5.5 15.0002V9.00024C5.5 7.06899 7.06875 5.50024 9 5.50024H15C16.9312 5.50024 18.5 7.06899 18.5 9.00024V15.0002Z"-->
          <!--                    fill="#0F0D3F"/>-->
          <!--                  <path-->
          <!--                    d="M12 8.00024C9.79063 8.00024 8 9.79087 8 12.0002C8 14.2096 9.79063 16.0002 12 16.0002C14.2094 16.0002 16 14.2096 16 12.0002C16 9.79087 14.2094 8.00024 12 8.00024ZM12 14.5002C10.6219 14.5002 9.5 13.3784 9.5 12.0002C9.5 10.6221 10.6219 9.50024 12 9.50024C13.3781 9.50024 14.5 10.6221 14.5 12.0002C14.5 13.3784 13.3781 14.5002 12 14.5002Z"-->
          <!--                    fill="#0F0D3F"/>-->
          <!--                  <path d="M16.5 8.00024C16.7761 8.00024 17 7.77639 17 7.50024C17 7.2241 16.7761 7.00024 16.5 7.00024C16.2239 7.00024 16 7.2241 16 7.50024C16 7.77639 16.2239 8.00024 16.5 8.00024Z"-->
          <!--                        fill="#0F0D3F"/>-->
        <!--                </svg>-->
      <!--              </a>-->
      <!--              <a *ngIf="socialLinks.vkLink" href="{{socialLinks.vkLink}}" target="_blank">-->
      <!--                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
      <!--                  <path-->
      <!--                    d="M18.4493 16.0002H16.9203C16.3414 16.0002 16.1633 15.559 15.1241 14.5483C14.2186 13.7084 13.8178 13.5946 13.5951 13.5946C13.2834 13.5946 13.1943 13.68 13.1943 14.0928V15.4166C13.1943 15.7725 13.0755 15.986 12.0958 15.986C10.4777 15.986 8.6815 15.0465 7.41969 13.2956C5.51957 10.7333 5 8.81163 5 8.41306C5 8.19953 5.08907 8.00024 5.51957 8.00024H7.04858C7.43454 8.00024 7.58299 8.17106 7.73143 8.56964C8.48852 10.6622 9.75032 12.4985 10.2699 12.4985C10.4629 12.4985 10.5519 12.4131 10.5519 11.9433V9.7796C10.4926 8.78316 9.9433 8.69775 9.9433 8.34188C9.9433 8.17106 10.0917 8.00024 10.3293 8.00024H12.7341C13.0607 8.00024 13.1795 8.17106 13.1795 8.54117V11.4593C13.1795 11.7725 13.3279 11.8864 13.417 11.8864C13.61 11.8864 13.7732 11.7725 14.1295 11.4308C15.228 10.2494 16.0148 8.42729 16.0148 8.42729C16.1187 8.21377 16.2969 8.01448 16.6828 8.01448H18.2118C18.672 8.01448 18.7759 8.24224 18.672 8.5554C18.479 9.4095 16.6086 11.9433 16.6086 11.9433C16.4453 12.1995 16.3859 12.3134 16.6086 12.5981C16.7719 12.8116 17.3063 13.2529 17.6626 13.6515C18.3157 14.3632 18.8205 14.9611 18.9541 15.3739C19.1025 15.7867 18.8798 16.0002 18.4493 16.0002Z"-->
      <!--                    fill="#0F0D3F"/>-->
    <!--                </svg>-->
  <!--              </a>-->
  <!--              <a *ngIf="socialLinks.facebookLink" href="{{socialLinks.facebookLink}}" target="_blank">-->
  <!--                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
  <!--                  <path-->
  <!--                    d="M13 12.9002H14.4286L15 10.5002H13V9.30024C13 8.68224 13 8.10024 14.1429 8.10024H15V6.08424C14.8137 6.05844 14.1103 6.00024 13.3674 6.00024C11.816 6.00024 10.7143 6.99444 10.7143 8.82024V10.5002H9V12.9002H10.7143V18.0002H13V12.9002Z"-->
  <!--                    fill="#0F0D3F"/>-->
<!--                </svg>-->
<!--              </a>-->
<!--              <a *ngIf="socialLinks.twitterLink" href="{{socialLinks.twitterLink}}" target="_blank">-->
<!--                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path-->
<!--                    d="M10.4603 17.0002C14.611 17.0002 16.8795 13.5366 16.8795 10.5338C16.8795 10.4345 16.8767 10.3379 16.874 10.2413C17.3151 9.92113 17.6986 9.52094 18 9.06556C17.5945 9.24771 17.1616 9.36915 16.7041 9.42435C17.1699 9.14284 17.5288 8.6985 17.6959 8.16584C17.2603 8.42527 16.7781 8.6157 16.263 8.71782C15.8521 8.27623 15.2658 8.00024 14.6164 8.00024C13.3699 8.00024 12.3589 9.01864 12.3589 10.2744C12.3589 10.4538 12.3781 10.6249 12.4164 10.7933C10.5425 10.6911 8.87945 9.78589 7.76438 8.41147C7.56986 8.74817 7.45753 9.13732 7.45753 9.55406C7.45753 10.3434 7.85479 11.0389 8.46301 11.4473C8.09315 11.4363 7.74521 11.3342 7.4411 11.1631C7.4411 11.1714 7.4411 11.1824 7.4411 11.1934C7.4411 12.2946 8.21918 13.2137 9.25205 13.4207C9.06301 13.4731 8.86301 13.5007 8.65753 13.5007C8.51233 13.5007 8.36986 13.4869 8.23288 13.4593C8.52055 14.3618 9.35342 15.0186 10.3397 15.038C9.56712 15.6479 8.59452 16.0122 7.53699 16.0122C7.35616 16.0122 7.17534 16.0012 7 15.9818C8 16.6221 9.18356 17.0002 10.4603 17.0002Z"-->
<!--                    fill="#0F0D3F"/>-->
<!--                </svg>-->
<!--              </a>-->
<!--              <a *ngIf="socialLinks.youtubeLink" href="{{socialLinks.youtubeLink}}" target="_blank">-->
<!--                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path d="M20.6216 7.87766C20.417 7.14218 19.8034 6.56153 19.0261 6.35831C17.625 6.00024 12 6.00024 12 6.00024C12 6.00024 6.375 6.00024 4.96364 6.35831C4.18636 6.55186 3.58295 7.1325 3.36818 7.87766C3 9.21315 3 12.0002 3 12.0002C3 12.0002 3 14.7873 3.37841 16.1228C3.58295 16.8583 4.19659 17.439 4.97386 17.6422C6.375 18.0002 12 18.0002 12 18.0002C12 18.0002 17.625 18.0002 19.0364 17.6422C19.8136 17.4486 20.417 16.868 20.6318 16.1228C21 14.7873 21 12.0002 21 12.0002C21 12.0002 21 9.21315 20.6216 7.87766ZM10.1591 14.5357V9.46476L14.8636 12.0002L10.1591 14.5357Z" fill="#0F0D3F"/>-->
<!--                </svg>-->
<!--              </a>-->
<!--              <a *ngIf="socialLinks?.telegramLink" href="{{socialLinks?.telegramLink}}" target="_blank">-->
<!--                <svg width="20" height="18" xmlns="http://www.w3.org/2000/svg" zoomAndPan="magnify" viewBox="0 0 26 26" preserveAspectRatio="xMidYMid meet" style="fill-rule:evenodd;">-->
<!--                  <path id="telegram-1" d="M18.384,22.779c0.322,0.228 0.737,0.285 1.107,0.145c0.37,-0.141 0.642,-0.457 0.724,-0.84c0.869,-4.084 2.977,-14.421 3.768,-18.136c0.06,-0.28 -0.04,-0.571 -0.26,-0.758c-0.22,-0.187 -0.525,-0.241 -0.797,-0.14c-4.193,1.552 -17.106,6.397 -22.384,8.35c-0.335,0.124 -0.553,0.446 -0.542,0.799c0.012,0.354 0.25,0.661 0.593,0.764c2.367,0.708 5.474,1.693 5.474,1.693c0,0 1.452,4.385 2.209,6.615c0.095,0.28 0.314,0.5 0.603,0.576c0.288,0.075 0.596,-0.004 0.811,-0.207c1.216,-1.148 3.096,-2.923 3.096,-2.923c0,0 3.572,2.619 5.598,4.062Zm-11.01,-8.677l1.679,5.538l0.373,-3.507c0,0 6.487,-5.851 10.185,-9.186c0.108,-0.098 0.123,-0.262 0.033,-0.377c-0.089,-0.115 -0.253,-0.142 -0.376,-0.064c-4.286,2.737 -11.894,7.596 -11.894,7.596Z"/>-->
<!--                </svg>-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->
<div class="footer__bottom-right">
  <div class="footer__develop">
    <a i18n="@@Development" href="https://www.compo.ru" target="_blank">Разработка <img src="/assets/images/logo.svg" width="100" alt=""> </a>
  </div>
</div>
</div>
</div>
</nb-layout-footer>
}


</nb-layout-column>
</nb-layout>
